export default {
    generalsPrudenceTips: [],
    prudenceTips: [],
    prudenceTipsHtml: ""
};
